import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import Vuex from 'vuex'
import { store } from './store';
import Api from "./helpers/api";
import VueSimpleAlert from "vue-simple-alert";
import Loading from 'vue-loading-overlay';
import VideoPlayer from 'vue-vjs-hls';
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import config from '../config';

import 'vue-loading-overlay/dist/vue-loading.css';
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

Vue.config.productionTip = false
VideoPlayer.config({
  youtube: true,  // default false
  switcher: true, // default true
  hls: true       // default true
})

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueSimpleAlert)
Vue.use(Loading);
Vue.use(VideoPlayer)

Api.init();

Sentry.init({
  Vue,
  environment: process.env.VUE_APP_WAKATOON_API_DEPLOY_STAGE,
  dsn: config.SENTRY_DNS,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "my-site-url.com", /^\//],
    }),
  ],
  tracesSampleRate: 1.0,
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
